import { classifyTransaction } from '../../../../lib/evm/transaction';
import { EvmApprovalCard } from './EvmApprovalCard';
import { EvmSignCard } from './EvmSignCard';
import { EvmTransactionCard } from './EvmTransactionCard';
import { EvmTxCardProps } from './types';

export const EvmTxCard = (props: EvmTxCardProps) => {
  const { evmData, uiData } = props;

  if (!evmData) {
    return (
      <p className="bitte-my-4 bitte-overflow-auto bitte-text-center">
        Unable to create evm transaction.
      </p>
    );
  }

  // Classify the transaction to determine which component to use
  const classification = classifyTransaction(evmData);

  // Route to the appropriate specialized component based on classification type
  if (classification.type === 'approval') {
    return (
      <EvmApprovalCard
        {...props}
        evmData={evmData}
        approvalInfo={classification.approval!}
        classification={classification}
      />
    );
  }

  if (classification.type === 'sign') {
    return (
      <EvmSignCard
        {...props}
        evmData={evmData}
        classification={classification}
      />
    );
  }

  // Default to generic transaction card
  return (
    <EvmTransactionCard
      {...props}
      evmData={evmData}
      uiData={uiData}
      classification={classification}
    />
  );
};
